module.exports = "<a class=\"faq\" target=\"_blank\"\n  href=\"https://www.madrid.es/portales/munimadrid/es/Inicio/Movilidad-y-transportes/Incidencias-de-Trafico/Principales-incidencias-en-la-ciudad/Preguntas-frecuentes-sobre-Informomadrid-/?vgnextfmt=default&vgnextoid=8772dd2812e84610VgnVCM1000001d4a900aRCRD&vgnextchannel=cbe0aa2dedcb1610VgnVCM2000001f4a900aRCRD\">\n</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/cities/informo/faq/faq.component.html
// module id = ./src/app/cities/informo/faq/faq.component.html
// module chunks = main